import { Component } from '@angular/core';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { HelpscoutService } from '../../../core/services/helpscout.service';

@Component({
  selector: 'app-confirm-become-beta-dialog',
  templateUrl: './confirm-become-beta-dialog.component.html',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose],
})
export class ConfirmBecomeBetaDialogComponent {
  constructor(public supportService: HelpscoutService) {}

  openSupportWidget() {
    this.supportService.toggle();
  }
}
